import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCartList, placeOrder } from "./cart-section.service";
import toast from "react-hot-toast";
import { CartContext } from "../../contexts/CartContext";

export default function CartSection() {
  // const [loader, setLoader] = useState(true);
  const { handleRemoveFromCart, cartItems, clearCart } =
    useContext(CartContext);
  const navigate = useNavigate();

  const handlePlaceOrder = () => {
    placeOrder().then((res) => {
      toast.success("Order placed successfully");
      clearCart();
      navigate("/order");
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="text-center">
        <h1>Your cart is empty</h1>
        <Link to="/products">Continue Shopping</Link>
      </div>
    );
  }

  return (
    <section className="ec-page-content section-space-p">
      <div className="container">
        <div className="row">
          <div className="ec-cart-leftside col-lg-12 col-md-12 ">
            {/* cart content Start */}
            <div className="ec-cart-content">
              <div className="ec-cart-inner">
                <div className="row">
                  <>
                    <div className="table-content cart-table-content">
                      <table>
                        <thead>
                          <tr>
                            <th>Image</th>
                            <th>Product Name</th>
                            <th>Product Code</th>
                            <th>Stock Status</th>
                            <th>Quantity</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cartItems.map((item: any) => (
                            <tr key={item.id}>
                              <td
                                data-label="Image"
                                className="ec-cart-pro-name"
                              >
                                <Link to={`/product/${item.productId}`}>
                                  <img
                                    className="ec-cart-pro-img mr-4"
                                    src={`https://d1gdand68muq63.cloudfront.net/${
                                      item.isSample
                                        ? "sample-products"
                                        : "products"
                                    }/96/${item?.productImage?.key}`}
                                    // src={`assets/images/product-image/${item.productImage.key}`}
                                    alt={item.productName}
                                  />
                                </Link>
                              </td>
                              <td
                                data-label="Product Name"
                                className="ec-cart-pro-name"
                              >
                                {item.productName}
                              </td>
                              <td
                                data-label="Product Code"
                                className="ec-cart-pro-code"
                              >
                                {item.productCode}
                              </td>
                              <td
                                data-label="Stock Status"
                                className="ec-cart-pro-stock"
                              >
                                In Stock
                              </td>
                              <td
                                data-label="Quantity"
                                className="ec-cart-pro-qty"
                                style={{ textAlign: "center" }}
                              >
                                <div className="cart-qty-plus-minus">
                                  <input
                                    className="cart-plus-minus"
                                    type="text"
                                    name="cartqtybutton"
                                    defaultValue={item.quantity}
                                  />
                                </div>
                              </td>
                              <td
                                data-label="Action"
                                className="ec-cart-pro-remove"
                              >
                                <div
                                  onClick={() => handleRemoveFromCart(item.id)}
                                >
                                  <i className="ecicon eci-trash-o" />
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="">
                      <div className="col-lg-12">
                        <div className="ec-cart-update-bottom">
                          <Link to="/products">Continue Shopping</Link>
                          <button
                            onClick={handlePlaceOrder}
                            className="btn btn-primary"
                          >
                            Place Order
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>
            {/*cart content End */}
          </div>
        </div>
      </div>
    </section>
  );
}
